import {
  CreditCardIcon,
  XMarkIcon,
  LockClosedIcon,
  ArrowLeftIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";
import { Formik, Form } from "formik";
import { fetchApi } from "./helpers"; // Consumir api
import WarningModal from "../components-modals/WarningModal"; // Modal mensajes para el usuario
import csLogo from "../components-layout/cs.png";
import mcLogo from "../components-layout/Mastercard-Logo.png";
import visaLogo from "../components-layout/visa.png";

import CreditCardInputs from "../../components/c&m/facturacion/CreditCardInputs";
import AdmisionCursosSeleccionados from "./AdmisionCursosSeleccionados";

const AdminPago = ({
  datosInscripcion,
  handleIdSeleccionado,
  planesVentana,
  Validar,
  propiedades,
  url,
  headers,
  IdEmp,
  seleccionado,
  CarnetEstudiante,
  data = [],
  datosInscripcionStep1,
  datosGradoParametro,
  rutaAlt,
  ...props
}) => {

  const [hasError, setHasError] = useState(false)

  const handleAtras = (values) => {
    handleIdSeleccionado(true);
    propiedades.form = 3;
    propiedades.valido = 1; // con 1 sale el form para ingresar nuevo, con 2 no aparece nada
    propiedades.paso = 2;
    Validar(propiedades);
  };

  const [loading, setLoading] = useState(false);

  const initialValues = {
    number: "",
    mmyy: "",
    code: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    pais: "",
    email: "",
  };

  //Manejo de errores

  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  const fetchData = async (data) => {
    setLoading(true);
    try {
      const res = await fetchApi({
        method: "POST",
        url: url + "/pagos/pagocybersource",
        headers,
        content: data,
      });

      setLoading(false);
      const { Error: err } = res?.msg[0];

      if (err !== "0") {
        throw new Error("ERR_CYBERSOURCE");
      }


      setModal({
        msg: "Transacción realizada con exito!",
        ok: true,
        show: true,
        reload: true,
      });
    } catch (err) {
      setLoading(false); // no estaba
      // console.log(err)
      const msg =
        err.message !== "ERR_CYBERSOURCE"
          ? "Por favor, intentelo de nuevo."
          : "Transacción denegada, revise sus datos.";

      setModal({
        ok: false,
        msg: msg,
        show: true,
        reload: false,
      });
    }
  };

  const handleSubmit = async (values) => {
    //console.log(values)
   // handleIdSeleccionado(false);

    const d = new Date().toLocaleDateString("es-GT");
    const fecha = d
      .split("/")
      .reverse()
      .map((x) => x.padStart(2, "0"))
      .join("");

    let { mmyy, ...resto } = values;
    let [mes, year] = mmyy.split("/");
    year = year ? "20" + year : "";

    //Formateo de formas de pago
    let FormasPago = [
      {
        tipotrans: "8",
        NoBoleta: "",
        CorrPOS: "0",
        IdBanco: "",
        Valor: data[0].ValorExa,
        Fecha: fecha,
        Saldo: data[0].ValorExa,
      },
    ];

    //Formateo de productos seleccionados
    let AlumnosCargos = [
      {
        Carnet: CarnetEstudiante,
        IdCiclo: "2024",
        IdCargo: data[0].IdCargoExa,
        Saldo: data[0].ValorExa,
        Abono: "0",
        NoPago: "1",
      },
    ];

    let dataPago = JSON.stringify({
      ...resto,
      monto: data[0].ValorExa,
      mes,
      year,
      CanalPago: "1",
      FormasPago,
      AlumnosCargos,
      IdEmp,
      HostName: "DEV1",
      IpHost: "131.107.1.235",
      OS: "Windows",
    });
    //dataPago.monto = dataPago.monto.toString()
    //dataPago.AlumnosCargos.Saldo = dataPago.AlumnosCargos.Saldo.toString()
    //dataPago.FormasPago.Saldo = dataPago.FormasPago.Saldo.toString()
    //dataPago.FormasPago.Valor = dataPago.FormasPago.Valor.toString()

    fetchData(dataPago);
  };

  return (
    <>
      <WarningModal
        open={loading ? true : false}
        image={<img src={rutaAlt} alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        </div>
      </WarningModal>
      <Formik
        initialValues={initialValues}
        //onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue, values, resetForm, errors, touched }) => {
          return (
            <Form>
              <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto">
                    <h1 className="text-lg font-semibold text-white">
                    PARA FINALIZAR LA SOLICITUD DEBES PAGAR LA {data[0].NombreCargo}
                    </h1>
                    <p className="px-2 text-base font-bold text-grisMira">
                      OPCIONES DE PAGO:
                    </p>
                    <p className="px-4 text-sm text-grisMira">
                    -Puedes realizar el pago directamente en las agencias de Interbanco o bien si eres cuentahabiente puedes realizarlo desde Intebanking únicamente con este código <strong><font size="3">{CarnetEstudiante}</font></strong>
                    
                    <br></br>-Tarjeta de crédito/débito desde esta página.
                    <br></br>
                    <br></br>Al realizar el pago recibirás un correo de confirmación con las indicaciones que debes seguir.
                    </p>
                  </div>
                </div>
                <div className="mt-5 lg:col-span-2 lg:mt-0">
                  <div className="px-4 mt-5 grid grid-cols-4 lg:grid-cols-6 sm:grid-cols-3 gap-3">
                    <p className="mt-1 text-base font-semibold text-white lg:col-start-1 lg:col-end-5 row-start-1">
                      {data[0].NombreCargo}
                    </p>
                    <p className="mt-1 ml-3 text-base font-semibold text-white lg:col-start-2 lg:col-end-4 row-start-1">
                      <span
                        className={"bg-green-500/80 px-2 py-1 rounded-full"}
                      >
                        {Intl.NumberFormat("es-GT", {
                          style: "currency",
                          currency: "GTQ",
                        }).format(data[0].ValorExa)}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="justify-items-center mt-2 xl:grid lg:grid-cols-12 gap-6">
                  <div className="mt-2 lg:col-span-3 lg:mt-0">
                    <div className="justify-items-center px-4 py-4 grid grid-cols-1 gap-6 rounded-lg bg-secundarioMira">
                      <div className="sm:col-span-6 lg:col-start-1 lg:col-end-12">
                      
                        <CreditCardInputs
                          setModal={setModal}
                          setFieldValue={setFieldValue}
                          values={values}
                          errors={errors}
                          touched={touched}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid col-span-2 rounded-lg mt-2 xl:mt-0">
                    <AdmisionCursosSeleccionados
                      datosInscripcion={(seleccionado ? 
                        (planesVentana.Carrera ? planesVentana : datosInscripcion.Carrera? datosInscripcion: datosGradoParametro )
                 : datosInscripcionStep1 )}//{}
                      color={"bg-secundarioMira"}
                    />
                  </div>
                </div>
                <div className="grid lg:grid-cols-6 md:grid-cols-2 sm:grid-cols-2 gap-6">
                  <div className="mt-2 col-span-full lg:col-start-2 lg:col-end-2 lg:row-start-1">
                    <button
                      type="button"
                      onClick={()=>handleSubmit(values)}
                      className="relative inline-flex justify-end rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                    >
                      <div className="flex">
                        <CreditCardIcon
                          className="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                        <p className="ml-1">Aceptar</p>
                      </div>
                    </button>
                  </div>
                  <div className="mt-2 lg:px-2 col-span-full lg:col-start-1 lg:col-end-1 lg:row-start-1">
                    <button
                      //type="submit"
                      onClick={() => handleAtras(props)}
                      className="relative inline-flex justify-end rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                    >
                      <div className="flex">
                        <ArrowLeftIcon
                          className="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                        <p className="ml-1">Atrás</p>
                      </div>
                    </button>
                  </div>
                </div>
                <div className="lg:flex sm:flex-row justify-start">

                  <div className="basis-1/4 ">

                  </div>
                  <div className="basis-1/6 bg-white rounded-lg mt-6 mb-2">

                  <div className=" grid grid-cols-3 ||-mb-4">
                      <div className="col-span-1 pl-2 ">
                        <img
                          className=" h-[30%] w-auto mx-auto bg-white mt-4 "
                          alt="Cybersource-logo"
                          src={csLogo}
                        ></img>
                      </div>
                      <div className="col-span-1">
                        <img
                          className=" h-[40%] w-auto mx-auto bg-white mt-4"
                          alt="Visa-logo"
                          src={visaLogo}
                        ></img>
                      </div>
                      <div className="col-span-1 lg:mb-2 ">
                        <img
                          className="h-[45%] w-auto mx-auto bg-white mt-4 mb-2"
                          alt="Mastercard-logo"
                          src={mcLogo}
                        ></img>
                      </div>
                    </div>
                  </div>
                  <div className="basis-1/2"></div>
                </div>

                <div className={"flex justify-center"}>
                  <LockClosedIcon
                    className="h-10 w-10 absolute rounded-md text-secundario"
                    aria-hidden="true"
                  />
                </div>

                <div className="text-center">
                  <p className="mt-10 text-base font-semibold text-secundario lg:col-start-1 lg:col-end-5 row-start-1">
                    Pago 100% seguro:
                    <br></br>
                    <div className="text-base font-semibold text-azulBrillanteMira lg:col-start-1 lg:col-end-5 row-start-1">
                      Todas nuestras transacciones en línea se realizan de forma
                      segura y con los estándares más altos de protección.
                    </div>
                  </p>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AdminPago;
